import { FileSizeExceededError } from '../FileSizeExceededError';
import { InvalidMimeTypeError } from '../InvalidMimeTypeError';

export const parseSpreadsheetErrors = (error: unknown): string => {
  if (error instanceof InvalidMimeTypeError) {
    return 'Não foi possível importar sua planilha pois seu formato não é aceito. Use .XLS ou .XLSX.';
  }
  if (error instanceof FileSizeExceededError) {
    return 'Não foi possível importar sua planilha pois ela é muito grande. Use uma planilha de até 1MB.';
  }

  return 'Ocorreu um erro ao ler o arquivo. Por favor, tente novamente.';
};
